module.exports = __webpack_public_path__ + "static/bg-masthead-d3b4a514dfb172f6ac1817f5bdb974ad.jpg";